<div class="menus-container">
    <menu-grid [sort]="sort()" [query]="search()" [limit]="20"></menu-grid>
</div>